import React, { useState } from 'react';

export const ToggleButtonCustom = (props) => {
//   const [selected, setSelected] = useState('BiWeekly');
  const {paymentCycle, setPaymentCycle} = props

  const handleClick = (option) => {
    setPaymentCycle(option);
  };

  return (
    <div className="flex bg-gray-800 p-1 rounded-full text-white">
      {['BiWeekly', 'Yearly'].map((option) => (
        <button
          key={option}
          onClick={() => handleClick(option)}
          style={{fontFamily: "Avenir"}}
          className={`px-4 py-1 rounded-full transition-colors duration-300 ${paymentCycle === option ? 'bg-gray-600' : 'bg-transparent'}`}
        >
          {option}
        </button>
      ))}
    </div>
  );
};
